import { Component, EventEmitter, Input, Output, Renderer2, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() titulo: string = 'Modal';
  @Input() mostrar: boolean = false;
  @Input() loading: boolean = false;
  @Input() btnAceptar: boolean = true;
  @Input() btnCerrar: boolean = true;
  @Input() isArchivo: boolean = false;
  @Input() labelBtnAceptar: string = 'Aceptar';
  @Input() labelBtnCerrar: string = 'Cerrar';

  @Output() aceptar = new EventEmitter<void>();
  @Output() mostrarChange = new EventEmitter<boolean>();
  @Output() cerrado = new EventEmitter<void>();

  constructor(
    private renderer: Renderer2
  ) {}

  onCerrar() {
    this.mostrar = false;
    this.mostrarChange.emit(false);
  }

  onAceptar() {
    this.aceptar.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mostrar'] && changes['mostrar'].previousValue === true && changes['mostrar'].currentValue === false) {
      this.renderer.removeClass(document.body, 'modal-open');
      this.cerrado.emit();
    }

    if (changes['mostrar'] && changes['mostrar'].currentValue === true) {
      this.renderer.addClass(document.body, 'modal-open');
    }
  }
}
